import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";

export default function ControlledRadioButtonsGroup({
  data = [],
  setDriverType,
  setOpertaorName,
  driverType,
  operatorName,
  basicDetails,
  setBasicDetails,
  setValidateLtfrb,
  carDetails,
  setCarDetails,
}) {
  // vehicle_type is UI-only — used to filter which vehicle categories to show.
  // It is NOT saved to basicDetails or sent to the API.
  const [vehicleType, setVehicleType] = useState("");

  useEffect(() => {
    if (carDetails?.carType) {
      if (["PEEKUP_BLUE", "PEEKUP_BLUE_XL"].includes(carDetails.carType)) {
        setVehicleType("Electric (EV)");
      } else if (["COMPACT", "PLUS", "EXECUTIVE"].includes(carDetails.carType)) {
        setVehicleType("Fuel/Gas");
      }
    }
  }, [carDetails?.carType]);

  const handleRadioChange = (event) => {
    setDriverType(event.target.value);
    setOpertaorName(""); // Reset the selected option when changing the radio option
    setVehicleType(""); // Reset local UI vehicle type
    setBasicDetails({
      ...basicDetails,
      tnvsCheck: "",
      operator_full_name: "",
    });
    setCarDetails({
      ...carDetails,
      carType: event.target.value === "VIA_OPERATOR" ? "TAXI" : "",
    });
  };

  const handleSelectChange = (event) => {
    if (driverType !== "VIA_OPERATOR") {
      setDriverType("VIA_OPERATOR");
    }
    setOpertaorName(event.target.value);
  };

  const labelStyle = {
    color: "#6F747E",
    fontFamily: "Proxima Nova",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    marginBottom: "4px",
    lineHeight: "normal",
  };

  return (
    <Box>
      <Typography sx={labelStyle}>Operator type</Typography>
      <RadioGroup row value={driverType} onChange={handleRadioChange} sx={{ marginBottom: "16px" }}>
        <FormControlLabel value="INDIVIDUAL" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="TNVS Operator" sx={{ width: "200px" }} />
        <FormControlLabel value="VIA_OPERATOR" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="TAXI Operator" />
      </RadioGroup>

      {driverType === "INDIVIDUAL" && (
        <Box>
          <Typography sx={labelStyle}>TNVS Driver Status</Typography>
          <RadioGroup
            row
            value={basicDetails?.tnvsCheck || ""}
            onChange={(e) => {
              setBasicDetails({
                ...basicDetails,
                tnvsCheck: e.target.value,
              });
              setValidateLtfrb(e.target.value === "false" ? true : null);
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="true" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Existing TNVS" sx={{ width: "200px" }} />
            <FormControlLabel value="false" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="New Applicant" />
          </RadioGroup>

          <Typography sx={labelStyle}>Vehicle Type</Typography>
          <RadioGroup
            row
            value={vehicleType}
            onChange={(e) => {
              setVehicleType(e.target.value);
              // Reset category when type changes
              setCarDetails({
                ...carDetails,
                carType: "",
              });
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="Fuel/Gas" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Fuel/Gas" sx={{ width: "200px" }} />
            <FormControlLabel value="Electric (EV)" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Electric (EV)" />
          </RadioGroup>

          {vehicleType && (
            <Box>
              <Typography sx={labelStyle}>Vehicle Category</Typography>
              <RadioGroup
                row
                value={carDetails?.carType || ""}
                onChange={(e) => {
                  setCarDetails({
                    ...carDetails,
                    carType: e.target.value,
                  });
                }}
                sx={{ marginBottom: "16px" }}
              >
                {vehicleType === "Electric (EV)" ? (
                  <>
                    <FormControlLabel value="PEEKUP_BLUE" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Blue - 4 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="PEEKUP_BLUE_XL" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Blue - 6 Seater" />
                  </>
                ) : (
                  <>
                    <FormControlLabel value="COMPACT" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Compact - 4 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="PLUS" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Plus - 6 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="EXECUTIVE" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Premium" sx={{ width: "200px" }} />
                  </>
                )}
              </RadioGroup>
            </Box>
          )}

          <Typography sx={labelStyle}>Operator Full Name</Typography>
          <TextField
            type="text"
            variant="outlined"
            size="small"
            color="secondary"
            value={basicDetails.operator_full_name}
            onChange={(e) => {
              setBasicDetails({
                ...basicDetails,
                operator_full_name: e.target.value,
              });
            }}
            sx={{ width: "100%", maxWidth: "380px", marginBottom: "16px" }}
          />
        </Box>
      )}

      {driverType === "VIA_OPERATOR" && (
        <Box>
          <Typography sx={labelStyle}>Operator Full Name</Typography>
          <Select
            value={operatorName}
            onChange={handleSelectChange}
            displayEmpty
            size="small"
            sx={{ width: "100%", maxWidth: "380px", marginBottom: "16px" }}
            inputProps={{ "aria-label": "select-option" }}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {data.map((option) => (
              <MenuItem value={option?.id} key={option.operator_name}>
                {option.operator_name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Box>
  );
}
